import {
    Button, Paper, Grid, TextField, FormControl, InputLabel, Select, Chip, Tabs, Tab, List, ListItem, ListItemIcon, IconButton,
    ListItemText, ListSubheader, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress
} from "@material-ui/core";
import * as React from "react";
import { observable, toJS, action } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { history } from "src/history.js";
import { authStore } from "src/modules/auth";
import { observer } from 'mobx-react';
import { withRouter } from 'react-router';
import RichTextEditor from 'react-rte';
import { supportStore } from '.';
// import ReactDropzone from 'react-dropzone';
import ReactDropzone from 'react-dropzone';
import Dropzone from 'react-dropzone';
import { assetStore } from '../asset';
import { Clear } from "@material-ui/icons";
import { validationsStore } from '../validations';
import { Loading } from 'src/components/loading';


type GroupName =
    | "INLINE_STYLE_BUTTONS"
    | "BLOCK_TYPE_BUTTONS"
    | "LINK_BUTTONS"
    | "BLOCK_TYPE_DROPDOWN"
    | "HISTORY_BUTTONS"
    | "IMAGE_BUTTON";

const displayTest: GroupName[] = ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS', 'IMAGE_BUTTON']

const styles = createStyles({
    root: {
        width: "100%",
        height: "100%",
        margin: "0 auto",
        // padding: "1.5rem",
        display: "flex",
        flexDirection: "column",
        overflow: 'hidden'
    },
    rowContainer: {
        width: "100%",
        display: "flex",
        alignContent: "center",
        margin: "0 auto",
        padding: "3rem",
    },
    textField: {
        // display: "flex",
        width: '400px',
        paddingRight: "24px",
    },
    submitButton: {
        marginTop: '10px'
    }
});

@observer
class SupportForm extends React.Component<any> {
    public toolbarConfig = {
        // Optionally specify the groups to display (displayed in the order listed).
        // display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS', 'IMAGE_BUTTON'],
        display: displayTest,
        INLINE_STYLE_BUTTONS: [
            { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
            { label: 'Italic', style: 'ITALIC' },
            { label: 'Underline', style: 'UNDERLINE' }
        ],
        BLOCK_TYPE_DROPDOWN: [
            { label: 'Normal', style: 'unstyled' },
            { label: 'Heading Large', style: 'header-one' },
            { label: 'Heading Medium', style: 'header-two' },
            { label: 'Heading Small', style: 'header-three' }
        ],
        BLOCK_TYPE_BUTTONS: [
            { label: 'UL', style: 'unordered-list-item' },
            { label: 'OL', style: 'ordered-list-item' },
        ],
    };

    @observable
    protected validations = {
        subject: {
            validateFunctions: [
                { functionName: 'regexTest', regexParam: /^\s*(?:[\w\.]\s*){5,50}$/, errorMessage: 'Subject must be more than 5 characters', active: true }
            ],
            valid: supportStore.newTicket.subject.length > 4,
            errorMessage: ['Subject must be more than 5 characters']
        },
    }

    constructor(props: any) {
        super(props);
        validationsStore.resetValidator();
    };

    public componentDidMount = () => {
        if (Object.entries(validationsStore.validator).length === 0) {
            validationsStore.startValidator(this.validations);
        }
        else {
            validationsStore.runValidator('subject', supportStore.newTicket['subject'] = supportStore.newTicket.subject);
        }
    }

    public handleInput(value: any, key: string) {
        supportStore.newTicket[key] = value;
        validationsStore.runValidator(key, supportStore.newTicket[key] = value)
    };

    public handleDrop = async (files: any) => {
        const data = new FormData();
        data.append('auth_id', authStore.currentUser.auth_id.toString())
        data.append('relation', 'freshdesk_ticket')
        data.append('relation_id', '0')
        files.forEach((file: any) => {
            data.append('assetFile', file)
        });
        const new_ids = await assetStore.insertAssetWithRelation(data);
        supportStore.newTicket.attachments = supportStore.newTicket.attachments.concat(new_ids);
    };

    public handleRemoveAsset = (asset_id: number) => {
        supportStore.newTicket.attachments = supportStore.newTicket.attachments.filter((item: any) => item.asset_id !== asset_id);
    };

    public handleSubmit = () => {
        supportStore.submitTicket();
        this.props.closeFunction();
    };

    public closeModal = () => {
        supportStore.ticketSuccessDialogOpen = false;
        supportStore.currentTab = 0;
    }

    public render() {
        const { classes } = this.props;

        const x = document.getElementsByClassName('DraftEditor-root') as HTMLCollectionOf<HTMLElement>;
        if (x.length > 0) {
            x[0].style.height = '260px'
        }

        if (!validationsStore.loaded) {
            return (<Loading />)
        }

        const successModal = () => {
            return (
                // tslint:disable-next-line: jsx-no-lambda
                <Dialog open={supportStore.ticketSuccessDialogOpen}>
                    <DialogTitle>Ticket submitted successfully</DialogTitle>
                    <DialogContent>
                        It will take about 30 seconds for Freshdesk to sync ticket
                    </DialogContent>
                    <DialogActions>
                        <Button
                            classes={{ root: classes.submitButton }}
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick={() => this.closeModal()}
                            variant='contained'
                        >
                            Continue
                            </Button>
                    </DialogActions>
                </Dialog>
            )
        }

        // const successModal = () => {
        //     let timeoutDone = false;
        //     setTimeout(
        //         () => {
        //             timeoutDone = true
        //         }, 2000
        //     )
        //     if (timeoutDone) {
        //         return (
        //             // tslint:disable-next-line: jsx-no-lambda
        //             <Dialog open={supportStore.ticketSuccessDialogOpen}>
        //                 <DialogTitle>Ticket submitted successfully</DialogTitle>
        //                 <DialogActions>
        //                     <Button
        //                         classes={{ root: classes.submitButton }}
        //                         // tslint:disable-next-line: jsx-no-lambda
        //                         onClick={() => this.closeModal()}
        //                         variant='contained'
        //                     >
        //                         Continue
        //                     </Button>
        //                 </DialogActions>
        //             </Dialog>
        //         )
        //     }
        //     else {
        //         return (<div>hold on</div>)
        //     }

        // }

        return (
            <Grid container={true} direction="column">

                <Grid
                    container={true}
                    // direction="row"
                    classes={{ container: classes.rowContainer }}
                    spacing={8}
                >
                    {/* <Grid item={true} xs={12} style={{ fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif' }}> */}
                        <div style={{ 
                            border: '1px solid #bbdcfe', 
                            backgroundImage: 'linear-gradient(#e5f2fd,#e5f2fd)', 
                            borderColor: '#bbdcfe', 
                            borderTopLeftRadius: '4px', 
                            borderTopRightRadius: '4px',
                            fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif',
                            width:'100%'
                        }}>
                            <Grid item={true} xs={12} style={{ margin: '10px' }}>
                                <TextField
                                    label="Subject"
                                    classes={{ root: classes.textField }}
                                    value={supportStore.newTicket.subject}
                                    InputLabelProps={{ shrink: true }}
                                    required={true}
                                    variant="outlined"
                                    // tslint:disable-next-line: jsx-no-lambda
                                    onChange={(e) => this.handleInput(e.target.value, "subject")}
                                    error={!validationsStore.validator["subject"].valid}
                                    helperText={
                                        !validationsStore.validator["subject"].valid
                                            ? validationsStore.validator["subject"].errorMessage.join()
                                            : " "
                                    }
                                />
                            </Grid>
                            <Grid item={true} xs={12}>
                                <RichTextEditor
                                    toolbarConfig={this.toolbarConfig}
                                    value={supportStore.newTicket.description}
                                    // tslint:disable-next-line: jsx-no-lambda
                                    onChange={(e) => this.handleInput(e, 'description')}
                                    className='h-full'
                                    editorStyle={{ 'minHeight': 300, backgroundImage: 'linear-gradient(#e5f2fd,#e5f2fd)' }}
                                />
                            </Grid>
                            <Grid container={true} spacing={8}>
                                <Grid item={true} xs={3}>
                                    {/* tslint:disable-next-line: jsx-no-lambda */}
                                    <Dropzone onDrop={acceptedFiles => this.handleDrop(acceptedFiles)}>
                                        {({ getRootProps, getInputProps }) => (
                                            <section>
                                                <div {...getRootProps()} style={{
                                                    border: '3px dashed white', padding: '20px', margin: '10px', maxWidth: '200px',
                                                    // background: 'radial-gradient(circle, rgba(199,45,45,0.7091211484593838) 0%, rgba(184,109,88,1) 100%)'
                                                    backgroundColor: 'white'
                                                }}>
                                                    <input {...getInputProps()} />
                                                    <p>Drop Attachments Here</p>
                                                </div>
                                            </section>
                                        )}
                                    </Dropzone>
                                </Grid>
                                <Grid item={true} xs={9}>
                                    <List>
                                        {supportStore.newTicket.attachments.map((attachment: any) => {
                                            return (
                                                <ListItem key={attachment.attachment_id}>
                                                    <ListItemIcon>
                                                        <IconButton
                                                            // tslint:disable-next-line: jsx-no-lambda
                                                            onClick={() => this.handleRemoveAsset(attachment.asset_id)}
                                                        >
                                                            <Clear />
                                                        </IconButton>
                                                    </ListItemIcon>
                                                    <ListItemText primary={attachment.AssetName} />
                                                </ListItem>
                                            )
                                        })}
                                    </List>
                                </Grid>
                            </Grid>
                        </div>
                        <Grid item={true} xs={3}>
                            <Button
                                classes={{ root: classes.submitButton }}
                                // tslint:disable-next-line: jsx-no-lambda
                                onClick={() => this.handleSubmit()}
                                variant='contained'
                                disabled={this.submitDisabled()}
                            >
                                Submit
                            </Button>
                        </Grid>
                    {/* </Grid> */}
                </Grid>
            </Grid>
        )

    }

    protected submitDisabled = () => {
        for (const key in validationsStore.validator) {
            if (validationsStore.validator.hasOwnProperty(key)) {
                if (!validationsStore.validator[key].valid) {
                    return true
                }
            }
        }
        return false
    }

}

export default withStyles(styles, { withTheme: true })(
    withRouter(SupportForm)
);


// WEBPACK FOOTER //
// ./src/modules/support/SupportForm.tsx